import React from 'react';
import { FileText } from 'lucide-react';

const Heading = ({ children }) => (
  <p className="font-['Barlow_Condensed'] text-lg font-bold uppercase text-[#0E3D95] mb-2">{children}</p>
);

const Swatches = ({ colors }) => {
  const groups = [...new Set(colors.map((c) => `${c.group}|${c.type || ''}`))];
  return (
    <div className="mt-5" data-testid="cfp-modal-colors">
      <Heading>Shell & Cabinet Colors</Heading>
      {groups.map((g) => {
        const [group, type] = g.split('|');
        return (
          <div key={g} className="mb-3">
            <p className="text-xs font-semibold uppercase tracking-wider text-[#F88200] mb-1">{group}{type ? ` · ${type}` : ''}</p>
            <div className="flex flex-wrap gap-3">
              {colors.filter((c) => `${c.group}|${c.type || ''}` === g).map((c) => (
                <div key={c.name} className="w-16 text-center">
                  <img src={c.image} alt={`${c.name} color`} loading="lazy" className="w-14 h-14 mx-auto rounded-full object-cover border border-slate-200" />
                  <p className="text-[11px] leading-tight text-slate-600 mt-1">{c.name}</p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const List = ({ title, items, testId }) => (
  <div className="mt-5" data-testid={testId}>
    <Heading>{title}</Heading>
    <ul className="grid gap-1 text-sm text-slate-600 list-disc pl-5">
      {items.map((f, i) => <li key={i}>{f}</li>)}
    </ul>
  </div>
);

export const ProductExtras = ({ item }) => (
  <>
    {item.keyFeatures?.length > 0 && (
      <List title="Key Features" items={item.keyFeatures.map((k) => `${k.label}: ${k.value}`)} testId="cfp-modal-key-features" />
    )}
    {item.features?.length > 0 && <List title="Standard Features" items={item.features} testId="cfp-modal-features" />}
    {item.upgrades?.length > 0 && <List title="Available Upgrades" items={item.upgrades} testId="cfp-modal-upgrades" />}
    {item.colors?.length > 0 && <Swatches colors={item.colors} />}
    {item.lighting?.length > 0 && (
      <div className="mt-5" data-testid="cfp-modal-lighting">
        <Heading>Lighting Packages</Heading>
        <div className="grid grid-cols-3 gap-3">
          {item.lighting.map((l) => (
            <div key={l.name} className="text-center">
              <img src={l.image} alt={`${l.name} lighting`} loading="lazy" className="w-full rounded-lg bg-slate-50" />
              <p className="text-xs font-semibold text-[#0E3D95] mt-1">{l.name}{l.lights ? ` · ${l.lights} lights` : ''}</p>
            </div>
          ))}
        </div>
      </div>
    )}
    {item.equipmentLayout && (
      <a href={item.equipmentLayout} target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 text-[#0E3D95] font-semibold hover:text-[#F88200]" data-testid="cfp-modal-equipment-layout">
        <FileText size={18} /> View Equipment Layout (PDF)
      </a>
    )}
  </>
);
